<template>
  <b-form-group
    label="Banka"
    label-for="id_banks"
  >
    <validation-provider
      #default="{ errors }"
      name="Banka"
      rules="required"
    >
      <v-select
        v-model="dataItem.id_banks"
        :options="banks"
        label="title"
        :reduce="item => item.id"
        placeholder="Banka"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'Banks',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
    banks() {
      return this.$store.getters['banks/dataList']
    },
  },
  created() {
    localize('tr')
    this.getBanks()
  },
  methods: {
    getBanks() {
      this.$store.dispatch('banks/getDataList', {
        select: [
          'banks.id AS id',
          'banks.title AS title',
        ],
      })
    },
  },
}
</script>
